import { Avatar, type AvatarProps } from '@/components/common';
import type { IntentionOption } from '@/constants/intentions';
import { cn } from '@/lib';

type AvatarSizeOptions = NonNullable<AvatarProps['size']>;
interface IntentionBadgeProps {
  option: IntentionOption;
  matches: boolean;
  size?: AvatarSizeOptions;
  className?: string;
}

export function IntentionBadge({ option, matches, size, className }: IntentionBadgeProps) {
  return (
    <Avatar
      src={option.icon}
      fallback=""
      border={matches}
      radius="medium"
      size={size}
      className={cn(
        'bg-linear-to-br! from-surface-dark to-surface-darker',
        matches ? 'opacity-100' : 'opacity-50',
        className
      )}
    />
  );
}
